import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  BRAND_ADD_REQUEST,
  BRAND_ADD_SUCCESS,
  BRAND_ADD_FAILURE,
  BRAND_EDIT_REQUEST,
  BRAND_EDIT_SUCCESS,
  BRAND_EDIT_FAILURE,
  BRAND_VIEW_REQUEST,
  BRAND_VIEW_SUCCESS,
  BRAND_VIEW_FAILURE,
  BRAND_VIEW_ALL_REQUEST,
  BRAND_VIEW_ALL_SUCCESS,
  BRAND_VIEW_ALL_FAILURE,
  BRAND_DELETE_REQUEST,
  BRAND_DELETE_SUCCESS,
  BRAND_DELETE_FAILURE,
  BRAND_RESET_STATE,
  BRAND_SEARCH_REQUEST,
  BRAND_SEARCH_FAILURE,
  BRAND_SEARCH_SUCCESS,
  BRAND_VIEW_BY_ALCOHOL_ID_REQUEST,
  BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS,
  BRAND_VIEW_BY_ALCOHOL_ID_FAILURE,
} from "./BrandTypes";

const initialState = {
  addBrand: { ...defaultStatus },
  editBrand: { ...defaultStatus },
  deleteBrand: { ...defaultStatus },
  viewBrand: { ...defaultStatus },
  viewAllBrands: { ...defaultStatus },
  viewBrandsByAlcoholId: { ...defaultStatus },
  viewAllSearchBrands: { ...defaultStatus },
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // Brand Reducers
    case BRAND_ADD_REQUEST:
      return {
        ...state,
        addBrand: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_ADD_SUCCESS:
      return {
        ...state,
        addBrand: { ...defaultStatus, success: true, ...payload },
      };
    case BRAND_ADD_FAILURE:
      return {
        ...state,
        addBrand: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case BRAND_EDIT_REQUEST:
      return {
        ...state,
        editBrand: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_EDIT_SUCCESS:
      return {
        ...state,
        editBrand: { ...defaultStatus, success: true, ...payload },
      };
    case BRAND_EDIT_FAILURE:
      return {
        ...state,
        editBrand: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case BRAND_VIEW_REQUEST:
      return {
        ...state,
        viewBrand: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_VIEW_SUCCESS:
      return {
        ...state,
        viewBrand: { ...defaultStatus, success: true, ...payload },
      };
    case BRAND_VIEW_FAILURE:
      return {
        ...state,
        viewBrand: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case BRAND_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllBrands: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllBrands: { ...defaultStatus, success: true, data: payload },
      };
    case BRAND_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllBrands: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case BRAND_VIEW_BY_ALCOHOL_ID_REQUEST:
      return {
        ...state,
        viewBrandsByAlcoholId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BRAND_VIEW_BY_ALCOHOL_ID_SUCCESS:
      return {
        ...state,
        viewBrandsByAlcoholId: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BRAND_VIEW_BY_ALCOHOL_ID_FAILURE:
      return {
        ...state,
        viewBrandsByAlcoholId: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case BRAND_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchBrands: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchBrands: { ...defaultStatus, success: true, data: payload },
      };
    case BRAND_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchBrands: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    case BRAND_DELETE_REQUEST:
      return {
        ...state,
        deleteBrand: { ...defaultStatus, inProgress: true, ...payload },
      };
    case BRAND_DELETE_SUCCESS:
      return {
        ...state,
        deleteBrand: { ...defaultStatus, success: true, ...payload },
      };
    case BRAND_DELETE_FAILURE:
      return {
        ...state,
        deleteBrand: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    case BRAND_RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
};

export default reducer;
